import axios from 'axios';
import { IGoogleMapsResponse } from 'props';

export const extractPostalCode = (address: string) => {
  const postalCodePattern = /\b\d{5}-\d{3}\b/; // Expressão regular para encontrar o CEP no formato XXXXX-XXX
  const match = address.match(postalCodePattern);
  return match ? match[0] : null;
};

export const getLocationByAddress = async (address: string) => {
  const proxyurl =
    process.env.NODE_ENV === 'development' ? 'https://cors-anywhere.herokuapp.com/' : '';
  const url = `https://maps.googleapis.com/maps/api/place/findplacefromtext/json?input=${address
    .split(' ')
    .join(
      '%20',
    )}&inputtype=textquery&fields=formatted_address%2Cname%2Crating%2Copening_hours%2Cgeometry&language=pt-BR&key=${
    process.env.REACT_APP_GOOGLE_MAPS_API_KEY
  }`;
  const data = await axios.get(proxyurl + url).then((response) => ({
    ...response.data,
    street: response.data?.candidates[0]?.formatted_address?.split(',')[0]?.trim(),
    number: response?.data?.candidates[0]?.formatted_address?.split(',')[1]?.split('-')[0]?.trim(),
    city: response?.data?.candidates[0]?.formatted_address?.split(',')[2]?.split('-')[0]?.trim(),
    uf: response?.data?.candidates[0]?.formatted_address?.split(',')[2]?.split('-')[1]?.trim(),
    postalCode: extractPostalCode(response?.data?.candidates[0]?.formatted_address),
  }));
  return data as IGoogleMapsResponse;
};

export const GetAddressByGeocoding = (coord: google.maps.LatLngLiteral) =>
  new Promise<{
    results: google.maps.places.PlaceResult[];
  }>((resolve, reject) => {
    axios
      .get(
        `https://maps.googleapis.com/maps/api/geocode/json?latlng=${coord.lat},${coord.lng}&key=${
          process.env.REACT_APP_GOOGLE_MAPS_API_KEY ?? ''
        }`,
      )
      .then(({ data }) => resolve(data))
      .catch(reject);
  });
